import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { AuthTokenConstants } from '../../constants/auth-constants';
import { DnvUserRoleType } from '../../constants/dnv-roles.constants';

@Injectable({
  providedIn: 'root',
})
export class CoBrowsingSharedService {
  private coBrowsingEndedSubject = new Subject<void>();
  private coBrowsingStartedSubject = new BehaviorSubject<string | null>(null);
  private coBrowsingCompanyChangedSubject = new Subject<void>();

  coBrowsingEnded$: Observable<void> =
    this.coBrowsingEndedSubject.asObservable();
  coBrowsingStarted$: Observable<string | null> =
    this.coBrowsingStartedSubject.asObservable();
  coBrowsingCompanyChanged$: Observable<void> =
    this.coBrowsingCompanyChangedSubject.asObservable();

  setCoBrowsingUserEmail(userEmail: string | null): void {
    localStorage.setItem(AuthTokenConstants.CO_BROWSING_EMAIL, userEmail ?? '');
  }

  getCoBrowsingUserEmail(): string | null {
    return localStorage.getItem(AuthTokenConstants.CO_BROWSING_EMAIL);
  }

  setCoBrowsingDnvUserAccess(dnvUserRoleType: DnvUserRoleType): void {
    localStorage.setItem(
      AuthTokenConstants.COBROWSING_DNV_USER_ACCESS,
      JSON.stringify(dnvUserRoleType),
    );
  }

  getCoBrowsingDnvUserAccess(): DnvUserRoleType {
    const data = localStorage.getItem(
      AuthTokenConstants.COBROWSING_DNV_USER_ACCESS,
    );

    return data ? JSON.parse(data) : null;
  }

  clearCoBrowsingDnvUserAccess(): void {
    localStorage.removeItem(AuthTokenConstants.COBROWSING_DNV_USER_ACCESS);
  }

  clearCoBrowsingSessionSubject(): void {
    this.coBrowsingStartedSubject.next(null);
  }

  emitCoBrowsingEnded() {
    this.coBrowsingEndedSubject.next();
  }

  emitCoBrowsingStarted(email: string) {
    this.coBrowsingStartedSubject.next(email);
  }

  emitCoBrowsingCompanyChanged() {
    this.coBrowsingCompanyChangedSubject.next();
  }
}
